/* predictive-search.js  -  EXACT MATCH dropdown
 * Replaces Shopify's fuzzy /search/suggest. Only products whose title / type / SKU
 * contain EVERY typed word are shown. Same product cache key as sections/search-exact.liquid.
 */
(function () {
  var CACHE_KEY = 'exact_search_products_v1';
  var MAX_ITEMS = 6;

  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(price) {
    var n = parseFloat(price);
    if (isNaN(n)) return '';
    try {
      var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? parseFloat(Shopify.currency.rate) : 1;
      var cents = Math.ceil(n * rate) * 100;
      if (window.Shopify && Shopify.formatMoney && window.theme && theme.moneyFormat) {
        return Shopify.formatMoney(cents, theme.moneyFormat);
      }
    } catch (e) {}
    return n.toFixed(2);
  }

  var productsPromise = null;
  function fetchAll(base) {
    var all = [];
    function page(n) {
      return fetch(base + '?limit=250&page=' + n)
        .then(function (r) { if (!r.ok) throw new Error(base + ' ' + r.status); return r.json(); })
        .then(function (j) {
          var items = j.products || [];
          items.forEach(function (p) {
            var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
            all.push({
              id: p.id, title: p.title, handle: p.handle, type: p.product_type || '',
              tags: tags.map(function (t) { return t.trim(); }),
              skus: (p.variants || []).map(function (v) { return v.sku || ''; }),
              price: p.variants && p.variants[0] ? p.variants[0].price : '',
              available: (p.variants || []).some(function (v) { return v.available; }),
              image: p.images && p.images[0] ? p.images[0].src : ''
            });
          });
          return items.length === 250 ? page(n + 1) : all;
        });
    }
    return page(1);
  }
  function loadProducts() {
    if (productsPromise) return productsPromise;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < 30 * 60 * 1000) {
        productsPromise = Promise.resolve(c.d);
        return productsPromise;
      }
    } catch (e) {}
    productsPromise = fetchAll('/collections/all/products.json')
      .catch(function () { return fetchAll('/products.json'); })
      .then(function (d) {
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        return d;
      })
      .catch(function (err) { productsPromise = null; throw err; });
    return productsPromise;
  }

  function search(products, term) {
    var words = norm(term).split(/\s+/).filter(Boolean);
    var phrase = norm(term);
    return products.filter(function (p) {
      if (p.tags.indexOf('hidden-product') > -1) return false;
      var hay = norm(p.title + ' ' + p.type + ' ' + p.skus.join(' '));
      for (var i = 0; i < words.length; i++) if (hay.indexOf(words[i]) === -1) return false;
      return true;
    }).sort(function (a, b) {
      var sa = norm(a.title).indexOf(phrase) > -1 ? 0 : 1;
      var sb = norm(b.title).indexOf(phrase) > -1 ? 0 : 1;
      return sa - sb || a.title.localeCompare(b.title);
    });
  }

  function buildMarkup(matches, term) {
    if (!matches.length) {
      return '<div class="predictive-search-results_dropdown-arrow"></div>' +
             '<div id="predictive-search-results" role="listbox"><div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">' +
             '<div class="search_not_found">No results found for &ldquo;' + esc(term) + '&rdquo;</div></div></div>';
    }
    var items = matches.slice(0, MAX_ITEMS).map(function (p, i) {
      var img = p.image ? p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=150' : '';
      return '<li id="predictive-search-option-product-' + (i + 1) + '" class="predictive-search__list-item" role="option" aria-selected="false">' +
        '<a href="/products/' + esc(p.handle) + '" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">' +
        (img ? '<img class="predictive-search__image" src="' + esc(img) + '" alt="' + esc(p.title) + '" width="50">' : '') +
        '<div class="predictive-search__item-content">' +
        '<p class="predictive-search__item-heading h5">' + esc(p.title) + '</p>' +
        '<div class="price">' + (p.available ? money(p.price) : 'Sold Out') + '</div>' +
        '</div></a></li>';
    }).join('');
    return '<div class="predictive-search-results_dropdown-arrow"></div>' +
      '<div id="predictive-search-results" role="listbox">' +
      '<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions">' +
      '<div class="predictive-search__result-group"><div>' +
      '<h2 id="predictive-search-products" class="predictive-search__heading text-body caption-with-letter-spacing">PRODUCTS</h2>' +
      '<ul id="predictive-search-results-products-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-products">' +
      items + '</ul></div></div></div>' +
      '<div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">' +
      '<button type="submit" class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" tabindex="-1" role="option" aria-selected="false">' +
      '<span data-predictive-search-search-for-text>View all (' + matches.length + ')</span></button></div></div>';
  }

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
      this.loader = this.querySelector('#predictive-search-loader');
      this.requestId = 0;
      if (!this.input) return;
      this.input.addEventListener('input', this.debounce(this.onChange.bind(this), 200));
    }

    onChange() {
      var term = this.input.value.trim();
      if (!term.length) { this.requestId++; this.close(); return; }
      this.getSearchResults(term);
    }

    getSearchResults(term) {
      var id = ++this.requestId;
      this.showLoader();
      loadProducts().then(function (products) {
        if (id !== this.requestId) return;
        this.predictiveSearchResults.innerHTML = buildMarkup(search(products, term), term);
        this.open();
      }.bind(this)).catch(function (err) {
        console.error('Exact predictive search failed:', err);
        this.close();
      }.bind(this)).then(function () {
        if (id === this.requestId) this.hideLoader();
      }.bind(this));
    }

    open() { this.predictiveSearchResults.style.display = 'block'; }
    close() { this.predictiveSearchResults.style.display = 'none'; this.hideLoader(); }
    showLoader() { if (this.loader) this.loader.style.display = 'block'; }
    hideLoader() { if (this.loader) this.loader.style.display = 'none'; }
    debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments, ctx = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    }
  }

  if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch);
})();